import React from "react"
import Img from "gatsby-image"
import classnames from "classnames/bind"
// Data
import useProjectData from "../../hook/projectpage-data"
// Component
import { MarqueeTitle } from "../../components/marquee"
import { FullSizeBlockNext } from "../../components/block"
import { Container } from "../../layouts/container"
// Style
import nextStyle from "../../style/section/projectpage/next.module.scss"

function ProjectNext(props) {
  // - Data
  const { edges } = useProjectData()

  return pug`
    div.projectNext.flex.justify-center.items-center.relative.text-white(className=nextStyle.wrapper)
      MarqueeTitle.pt-4(title="find out more about next project" color="txt-hasShadow-dark")
      Container(className=nextStyle.project)
        each items,index in edges
          //- Find the next project
          if (index==props.index )
            - const projectData = items.node.data
            FullSizeBlockNext(
              key=items.node.id
              link="/projects/"+items.node.uid
              title=projectData.project_name.text
              image_url=projectData.hero_image.fluid
              image_alt=projectData.hero_image.alt
              cate=projectData.timeline.text
              description=projectData.project_description.text
            )

  `
}

export default ProjectNext
